export default __webpack_public_path__ + "static/media/lu.6533f563.jpg";